import React from "react";

// third-party
import { FormattedMessage } from "react-intl";

// assets
import {
  IconUserCheck,
  IconBasket,
  IconMessages,
  IconMail,
  IconCalendar,
  IconNfc,
  IconBuildingStore,
} from "@tabler/icons";

// constant
const icons = {
  IconUserCheck: IconUserCheck,
  IconBasket: IconBasket,
  IconMessages: IconMessages,
  IconMail: IconMail,
  IconCalendar: IconCalendar,
  IconNfc: IconNfc,
  IconBuildingStore: IconBuildingStore,
};

//-----------------------|| Booking MENU ITEMS ||-----------------------//

export const Aspire = {
  id: "Aspire Order",
  title: <FormattedMessage id="Aspire Order" />,
  type: "group",
  children: [
    {
      id: "Aspire Order",
      title: <FormattedMessage id="Aspire Order" />,
      type: "collapse",
      icon: icons["IconBuildingStore"],
      children: [
        {
          id: "Upload Payment proof",
          title: <FormattedMessage id="upload-payment-proof" />,
          type: "item",
          url: "/aspire/upload-payment-proof",
        },
      ],
    },
  ],
};
